const sectionBannerBasicCss = `
[data-type='section-banner-basic'] .banner-basic-wrapper {
  background-color: var(--background-color, #ffffff);
}

[data-type='section-banner-basic'] .banner-basic-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-banner-basic'] .banner-basic-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-banner-basic'] .banner-basic-cards-top {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

[data-type='section-banner-basic'] .banner-basic-card-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--card-1-background-color, #01ae74);
  padding: 32px 8px;
}

[data-type='section-banner-basic'] .banner-basic-card-1 .banner-basic-card-1-image {
  width: 50%;
  height: auto;
}

[data-type='section-banner-basic'] .banner-basic-card-1 .banner-basic-card-1-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-banner-basic'] .banner-basic-card-1 .banner-basic-card-1-text {
  font-size: 18px;
  font-weight: 700 !important;
  margin: 0;
  padding: 0;
  color: var(--card-1-text-color, #ffffff);
  margin-top: 32px;
  text-align: center;
}

[data-type='section-banner-basic'] .banner-basic-card-1 .banner-basic-card-1-button {
  margin-top: 20px;
  background-color: var(--button-background-color, #464646);
  color: var(--button-text-color, #ffffff);
  padding: 10px 20px;
  border-radius: var(--button-radius, 5px);
  width: fit-content;
  font-size: 14px;
  line-height: normal;
  font-weight: 500 !important;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

[data-type='section-banner-basic'] .banner-basic-card-2-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

[data-type='section-banner-basic'] .banner-basic-card-2-image-wrapper .banner-basic-card-2-image {
  width: 100%;
  height: 100%;
}

[data-type='section-banner-basic'] .banner-basic-card-2-image-wrapper .banner-basic-card-2-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-banner-basic'] .banner-basic-cards-bottom {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

[data-type='section-banner-basic'] .banner-basic-card-3 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--card-3-background-color, #efefef);
  height: 100%;
  gap: 16px;
  padding: 32px 8px;
}

[data-type='section-banner-basic'] .banner-basic-card-3 .banner-basic-card-3-image {
  width: 100px;
  min-width: 100px;
  height: auto;
}

[data-type='section-banner-basic'] .banner-basic-card-3 .banner-basic-card-3-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-banner-basic'] .banner-basic-card-3 .banner-basic-card-3-text {
  font-size: 20px;
  line-height: normal;
  color: var(--card-3-text-color, #6d6d6d);
}

[data-type='section-banner-basic'] .banner-basic-card-4-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: var(--card-4-background-color, #464646);
  padding: 32px 8px;
}

[data-type='section-banner-basic'] .banner-basic-card-4-image-wrapper .banner-basic-card-4-image {
  width: 250px;
  height: auto;
}

[data-type='section-banner-basic'] .banner-basic-card-4-image-wrapper .banner-basic-card-4-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-banner-basic'] .banner-basic-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-banner-basic'] .banner-basic-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-banner-basic'] .banner-basic-cards-top {
    grid-template-columns: 1fr;
  }

  [data-type='section-banner-basic'] .banner-basic-card-3 .banner-basic-card-3-image {
    width: 50px;
    min-width: 50px;
  }

  [data-type='section-banner-basic'] .banner-basic-card-3 .banner-basic-card-3-text {
    font-size: 14px;
  }

  [data-type='section-banner-basic'] .banner-basic-card-4-image-wrapper .banner-basic-card-4-image {
    width: 100px;
  }
}
`;
export default sectionBannerBasicCss;
